<template>
  <div class="text-center">
    <hr class="mt-6 mb-4" />

    <slot>
      <p class="info">
        Questions? We're here to help.
        <a href="mailto:support@promo.ai?subject=Support Question">
          Email us
        </a>
        or visit our
        <a
          href="http://help.promo.ai/category/newsletters-by-promo-ai/"
          target="_blank"
        >
          help center
        </a>
      </p>
    </slot>
  </div>
</template>

<script>
export default {
  name: "ModalFooter",
};
</script>

<style scoped>
.info {
  @apply text-sm text-support-light mb-0;
}
</style>
